module.exports = __webpack_public_path__ + "media/images/new/public_land_map_overlays_laptop@2x-292c67d997cf658cccf91ed81fdba76b.png";